var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dev-portal-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dev-portal-structure",
    transform: "translate(-1648.000000, -34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-26",
    transform: "translate(1647.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    fillRule: "nonzero",
    cx: 12,
    cy: 9.01024723,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23759694,18.3244686 L7.2803858,16.2807733 C8.10470235,15.7271194 9.07520541,15.4314496 10.068196,15.4314496 L13.9304444,15.4314496 C14.9002019,15.4314496 15.8490322,15.7134574 16.6613644,16.2431235 L19.7971954,18.2877837 L19.7971954,18.2877837",
    id: "Path-Copy",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    cx: 12,
    cy: 12,
    r: 10.0108128
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.30acbdbbde6bd8184281bd5a9f9ad504.svg";
export { ForwardRef as ReactComponent };